import { Text } from '@mxenabled/mxui'

import { Dialog, useGlobalCopyStore } from '../../../common'

interface MarkAsPaidDialogProps {
  isOpen: boolean
  onClose: () => void
  onLinkTransaction: () => void
}

export const MarkAsPaidDialog = ({ isOpen, onClose, onLinkTransaction }: MarkAsPaidDialogProps) => {
  const { recurring: copy } = useGlobalCopyStore()

  return (
    <Dialog
      copy={{
        title: copy.mark_as_paid_dialog_title,
        close_aria: copy.close_drawer_aria,
      }}
      isOpen={isOpen}
      maxWidth="xs"
      onClose={onClose}
      onPrimaryAction={onLinkTransaction}
      primaryText={copy.link_transaction_button}
      sx={{
        '& .MuiStack-root, & .MuiDialogContent-root': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Text truncate={false}>{copy.link_transaction_description}</Text>
    </Dialog>
  )
}
